import { Row, Stack } from '@appcues/sonar';
import { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { BacklinkProps } from './BackLink';

const backlinkStyles = css`
  padding-left: var(--spacing-x-x-x-large);
`;

const secondaryRowStyles = css`
  gap: var(--spacing-regular, 16px);
  padding-top: var(--spacing-x-large);
  padding-bottom: var(--spacing-regular);
`;

export const Root = styled.header`
  display: flex;
  flex-direction: column;
  background-color: var(--color-neutral-0);
  border-bottom: 1px solid var(--border-default);
  min-height: 100px;
  width: 100%;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const Container = styled(Stack)<{
  $backlinkProps?: BacklinkProps;
  $secondaryRow?: ReactNode;
  $fullWidth?: boolean;
}>`
  min-height: inherit;
  width: 100%;
  max-width: 1400px;
  padding-left: var(--spacing-x-large);
  padding-right: var(--spacing-x-large);
  justify-content: center;

  @media (min-width: 1366px) {
    padding-left: var(--spacing-x-x-x-large);
    padding-right: var(--spacing-x-x-x-large);
  }
  /* always keep the padding-left size at its biggest value when the backlink is displayed */
  ${({ $backlinkProps }) => $backlinkProps && backlinkStyles}

  /* don't show the gap when the header has only one row */
  ${({ $secondaryRow }) => $secondaryRow && secondaryRowStyles}

  ${({ $fullWidth }) => $fullWidth && 'max-width: 100%;'}
`;

export const PrimaryRow = styled(Row).attrs({
  spacing: 'regular',
  xAlign: 'space-between',
  yAlign: 'center',
})`
  position: relative;
  width: 100%;
`;

export const TitleContainer = styled(Row).attrs({
  spacing: 'regular',
  yAlign: 'center',
})`
  max-width: 90%;
`;

export const SecondaryRow = styled(Row).attrs({
  spacing: 'regular',
})`
  width: 100%;
`;

export const DescriptionContainer = styled(Row).attrs({
  spacing: 'small',
  xAlign: 'end',
})`
  flex: 1;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-regular);
`;
